import { Dialog, DialogTitle } from "@mui/material";
import { ReactElement, useState } from "react";

import EditTagForm from "./EditTagForm";
import EditTagGroupForm from "./EditTagGroupForm";
import {
  EditTagFormType,
  EditTagGroupFormType,
  NgpVanIntegration,
} from "./types";

export default function CreateTagOrGroupDialog({
  open,
  onClose,
  onCreateTag,
  onCreateTagGroup,
  vanIntegrations,
  allTagNames,
}: {
  open: boolean;
  onClose: () => void;
  onCreateTag: (formData: EditTagFormType) => Promise<void>;
  onCreateTagGroup: (formData: EditTagGroupFormType) => Promise<void>;
  vanIntegrations: NgpVanIntegration[];
  allTagNames: string[];
}): ReactElement {
  const [fieldName, setFieldName] = useState("");
  const [type, setType] = useState<"flat" | "singleSelect">("flat");

  function handleTypeChange(name: string, newType: "flat" | "singleSelect") {
    setFieldName(name);
    setType(newType);
  }

  function renderDialogContent() {
    if (type === "flat") {
      return (
        <EditTagForm
          onTypeChange={handleTypeChange}
          initialName={fieldName}
          onSave={onCreateTag}
          onCancelClick={onClose}
          vanIntegrations={vanIntegrations}
          allOtherTagNames={allTagNames}
        />
      );
    }

    if (type === "singleSelect") {
      return (
        <EditTagGroupForm
          onTypeChange={handleTypeChange}
          initialName={fieldName}
          onSave={onCreateTagGroup}
          onCancelClick={onClose}
          vanIntegrations={vanIntegrations}
          allOtherTagNames={allTagNames}
        />
      );
    }

    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>New Tag</DialogTitle>
      {renderDialogContent()}
    </Dialog>
  );
}
